var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "computer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.932,
    height: 52.726,
    viewBox: "0 0 52.932 52.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26939",
    "data-name": "Trac\\xE9 26939",
    d: "M40.033,4H8A3.992,3.992,0,0,0,4,7.983v23.9a3.992,3.992,0,0,0,4,3.983H20.015v3.983H14.009V43.83H34.027V39.847H28.022V35.864H40.033a3.992,3.992,0,0,0,4-3.983V7.983A3.992,3.992,0,0,0,40.033,4Zm0,27.881H8V7.983H40.033Z",
    transform: "translate(2.448 2.448)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26940",
    "data-name": "Trac\\xE9 26940",
    d: "M0,0H52.932V52.726H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.90e140d8ea5d1d04a6e07822fd69b430.svg";
export { ForwardRef as ReactComponent };